import useIntersectionObserver from 'app/features/conversations/Hooks/useIntersectionObserver';
import Spinner from '.';

export default function LoadingSpinner({
  active,
  loadMore,
}: {
  active: boolean;
  loadMore: () => void;
}) {
  const ref = useIntersectionObserver({
    active: active,
    onIntersection: loadMore,
  });

  return <div className="shrink-0">{active && <Spinner ref={ref} />}</div>;
}
